import React, { useState } from 'react'
import Header from './header'
import EligiblityCheck from './EligiblityCheck'
import Summary from '../consumer/kyc/summary'
import { useSelector } from "react-redux";

function EligiblitySteps() {
  const [dealerCode, setDealerCode] = useState()
  const { subStage } = useSelector(state => state.eligibility)

  return (
    <>
      <Header dealerCode={dealerCode}/>
      {subStage !== 'kyc-summary' && <EligiblityCheck setDealerCode={setDealerCode} />}
      {subStage === 'kyc-summary' && <Summary setDealerCode={setDealerCode} />}
    </>
  )
}

export default EligiblitySteps